import { Box, Typography } from '@mui/material';
import React from 'react';

const Reports = () => {
  return (
    <Box>
      <Typography variant="h4">Reports</Typography>
      <Typography variant="body1">Management Reports Page</Typography>
    </Box>
  );
};

export default Reports;
